import React, { useState } from 'react';

import usePost from '../hooks/usePost';

import Loading from './loading';
import Error from './error';

import Table from '../components/table';

import iUser from '../interfaces/User';

import BlockIcon from '@material-ui/icons/Block';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import RemoveCircleOutlineRoundedIcon from '@material-ui/icons/RemoveCircleOutlineRounded';

interface UsersTableProps {
  data: iUser[];
}

interface UserState {
  email: iUser['email'];
  isBanned: iUser['isBanned'];
  isConfirmed: iUser['isConfirmed'];
  isDeleted: iUser['isDeleted'];
}

function updateUserState(
  users: iUser[],
  { email, isBanned, isConfirmed, isDeleted }: UserState
) {
  if (isDeleted) {
    return users.filter((user: iUser) => user.email !== email);
  }

  const userIndex = users.findIndex((user: iUser) => user.email === email);
  const updatedUsers = [...users];
  updatedUsers[userIndex] = {
    ...users[userIndex],
    isBanned,
    isConfirmed,
    isDeleted,
    banned: isBanned ? 'Banned' : 'Not banned',
    confirmed: isConfirmed ? 'Confirmed' : 'Not confirmed',
  };
  return updatedUsers;
}

export default function UsersTable({ data }: UsersTableProps) {
  const [user, setUser] = useState<UserState>({
    email: '',
    isBanned: false,
    isConfirmed: false,
    isDeleted: false,
  });

  const [response, updateUser] = usePost({
    path: 'main',
    payload: { btn: 'update_user' },
  });

  function cbUpdateUser(rowData: iUser, name?: string) {
    const isBan = name === 'ban' ? !rowData.isBanned : rowData.isBanned;
    const isConfirm =
      name === 'confirm' ? !rowData.isConfirmed : rowData.isConfirmed;
    const isDelete = name === 'delete' ? true : false;
    updateUser({
      email: rowData.email,
      ban: Number(isBan),
      confirm: Number(isConfirm),
      delete: isDelete,
    });
    setUser({
      ...user,
      email: rowData.email,
      isBanned: isBan,
      isConfirmed: isConfirm,
      isDeleted: isDelete,
    });
  }

  function setBanIcon(rowData: iUser) {
    return rowData.isBanned ? RadioButtonUncheckedIcon : BlockIcon;
  }

  function setConfirmIcon(rowData: iUser) {
    return rowData.isConfirmed
      ? CheckCircleOutlineRoundedIcon
      : RadioButtonUncheckedIcon;
  }

  return (
    <>
      <div style={{ maxWidth: '100%' }}>
        <Table
          columns={[
            { title: 'Email', field: 'email' },
            { title: 'Confirmation', field: 'confirmed' },
            { title: 'Ban', field: 'banned' },
            { title: 'Date Created', field: 'dateCreated' },
            { title: 'Time Created', field: 'timeCreated' },
          ]}
          data={response.data ? updateUserState(data, user) : data || []}
          title="Users"
          actions={[
            { iconCb: setConfirmIcon, cb: cbUpdateUser, name: 'confirm' },
            { iconCb: setBanIcon, cb: cbUpdateUser, name: 'ban' },
            {
              icon: RemoveCircleOutlineRoundedIcon,
              cb: cbUpdateUser,
              tooltip: 'Delete user',
              name: 'delete',
            },
          ]}
        />
      </div>
      <Error error={response.error} />
      <Loading loading={response.isLoading} />
    </>
  );
}
